(ns pfo.collection.component
  (:require
   [clojure.string :as str]
   [reagent.core :as reagent :refer [atom track!]]
   [taoensso.timbre :as timbre
    :refer [log trace debug info warn error fatal report logf
            tracef debugf infof warnf errorf fatalf reportf spy]]
   [dommy.core :as dommy :refer-macros [sel sel1]]
   [applied-science.js-interop :as j]
   [goog.object :as go]
   [ajax.json :refer [json-request-format]]
   [pfo.collection.model :as model]
   [pfo.coltype.model :as coltype-model]
   [pfo.coltype.components.details :refer [collection-coltype-details filter-form-data]]
   [pfo.widget.accordion :refer [accordion]]
   [pfo.auth.model :as auth-model :refer [perm has-family-perm has-any-of-perms-in-family ]]
   [pfo.admin.model :as admin-model]
   [pfo.widget.tabs :refer [tabs tab tab-header tabs-header tabs-header-and-content]]
   [pfo.revroutes :refer [path-for go-to-last-waypoint]]
   [pfo.widget.tree :refer [tree-view]]
   [pfo.state :as state]
   [pfo.util :as util :refer [classes event-value reset-from-event]]
   [pfo.widget.paginator :refer [paginator load-more tfoot-paginator]]
   [pfo.flash :refer [set-flash]]
   [pfo.form :as form :refer [set-selected set-checked]]
   [pfo.api :as api :refer [process-error]]
   [pfo.activity.component :as activity]
   [pfo.task.component :as task]
   [pfo.common.component :refer [content topbar topbar2 toolbar toolbar-item header]]
   [pfo.automation.component :as automation]
   [pfo.document.component :as document]
   [pfo.assignment.component :refer [collection-name nav-search]]
   ["react-select" :default Select :refer [createFilter components]]
   [pfo.automation.component :refer [disposition-name
                                     disposition-and-label-chooser
                                     chooser-dispositions-atom
                                     chooser-labels-atom
                                     chooser-disposition-value-atoms
                                     update-disposition-choices!]]
   [pfo.widget.autocomplete :refer [primary-theme]]
   [pfo.automation.model :as automation-model]
   [promesa.core :as p]
   [secretary.core :as secretary]
   [pfo.common.component :refer [sidebar] :as common]
   [pfo.controller :as controller :refer [subscribe]]
   [pfo.widget.list :refer [orderer]]
   [pfo.revroutes :refer [path-for set-waypoint go-to-deletion-waypoint]]
   [pfo.widget.orgchart :refer [org-chart]]
   [pfo.widget.help :refer [help-popover]]))

(declare nav-groups add-level-from-index task-list task-list-buttons common-task-list
  collection-default-filter boir-transmission-details)

(def catom clojure.core/atom)

(defn breadcrumb
  ([ancestor-list include-last]
   [:div.breadcrumb
    (for [ancestor (butlast ancestor-list)]
      [:span {:key (:id ancestor)} 
       [:span {:style {:white-space :nowrap}}
        (if (:has_any_permission ancestor)
          [:a {:href (str "#/collection/details/" (:id ancestor))} (collection-name ancestor)]
          (collection-name ancestor))
        " / "] " "])
    (when include-last (collection-name (last ancestor-list))) ])
  ([ancestor-list] (breadcrumb ancestor-list true)))

(defn collection-service-item-add [family-id collection-id]
  (let [show-menu (atom false)
        ref (atom nil)]

    (reagent/create-class
      {:display-name "collection-service-item-add"
       :component-did-mount #(-> (js/$ "div.outer-container")
                                 (.click (fn [e]
                                           (when-not (= (-> e .-target) @ref)
                                             (do
                                               (reset! show-menu false)
                                               (-> (js/$ "ul.dropdown-menu.dropdown-select") (.removeClass "show")))))))
       :reagent-render (fn [options]
                         [:div.dropdown {:key :add}
                          (when (has-any-of-perms-in-family
                                  family-id
                                  #{:can_add_task
                                    :can_add_compliance
                                    :can_add_event})
                            [:div.dropdown-container
                             [:span.controls
                              [:button {:ref (fn [com] (reset! ref com)) :on-click #(swap! show-menu not)} "Add Item"]]
                             [:ul.dropdown-menu.dropdown-select (when @show-menu {:class "show"} )
                              (when (has-family-perm family-id :can_add_task)
                                [:li {:on-click #(util/set-location (str "#/task/add/?task_type=task&action_type=simple&collection_id=" collection-id))}
                                 "Task"])
                              (when (has-family-perm family-id :can_add_compliance)
                                [:li {:on-click #(util/set-location (str "#/task/add/?task_type=compliance&action_type=apply&collection_id=" collection-id))}
                                 "Compliance"])
                              (when (has-family-perm family-id :can_add_event)
                                [:li {:on-click #(util/set-location (str "#/event/add/?collection_id=" collection-id))}
                                 "Event"])]])])})))

(defn collection-service-filter-list [task-tabs-active task-filter-show compliance-filter-show event-filter-show]

  (let [show-menu (atom false)
        ref (atom nil)
        set-task-tab (fn [tab-to-set]

                       (case tab-to-set
                         :tasks (reset! task-filter-show true)
                         :compliance (reset! compliance-filter-show true)
                         :events (reset! event-filter-show true))

                       (reset! task-tabs-active tab-to-set))]

    (reagent/create-class
      {:display-name "collection-service-filter-list"

       :component-did-mount #(-> (js/$ "div.outer-container")
                                 (.click (fn [e]
                                           (when-not (= (-> e .-target) @ref)
                                             (do
                                               (reset! show-menu false)
                                               (-> (js/$ "ul.dropdown-menu.dropdown-select") (.removeClass "show")))))))

       :reagent-render (fn [task-tabs-active task-filter-show compliance-filter-show event-filter-show ]

                         [:div.dropdown
                          [:div.dropdown-container
                           [:span.controls
                            [:button {:ref (fn [com] (reset! ref com)) :on-click #(swap! show-menu not)} "Filter"]]
                           [:ul.dropdown-menu.dropdown-select (when @show-menu {:class "show"} )

                            [:li {:on-click #(set-task-tab :tasks)} "Tasks"]

                            [:li {:on-click #(set-task-tab :compliance)} "Compliance"]

                            [:li {:on-click #(set-task-tab :events)} "Events"]]]])})))

(defn details-switch [filter-show-atoms]
  [toolbar-item "Details" @state/sidebar-active (util/handler (fn []
                                                                (swap! state/sidebar-active not)
                                                                (when @state/sidebar-active
                                                                  (doseq [filter-show-atom filter-show-atoms]
                                                                    (reset! filter-show-atom false)))))])

(defn compliance-controls [family collection compliance-filter-show compliance-bulk-edit report-mode options]
  [:div.tab-controls.o-margin-elements--medium
   [collection-service-item-add (:id family) (:id collection)]
   (when (and @compliance-filter-show (not @report-mode)) [:button {:on-click (util/handler (fn []
                                                                     (swap! compliance-bulk-edit (fn [old-value] (case old-value
                                                                                                                   nil :filter
                                                                                                                   :filter nil)))
                                                                     (when-not @compliance-bulk-edit
                                                                       (reset! (:show-steps-atom options) false)
                                                                       (reset! (:chosen-tasks-atom options) #{})
                                                                       (reset! (:select-all-atom options) false))))}
                                  "Bulk edit"])
   [task/report-mode-button {:filter-collection-id-atom (atom (or (:id collection) false))} report-mode]
   [:button (merge
              {:on-click (util/handler #(swap! compliance-filter-show not))}
              (when @compliance-bulk-edit {:disabled :disabled})) "Filter"]])

(defn disposition-list-manager [{:keys [edit-atom]
                                 :as options}
                                value-atom]
  (let [original-value @value-atom]
    (fn []
      [:div.u-width--full.c-collection-disposition-chooser {:style {:display "inline-block"}}
       [disposition-and-label-chooser
        (merge {:allow-empty true
                :allow-create-new true
                :change-cb (fn [value]
                             (update-disposition-choices! (:dispositions-atom options) value)
                             (swap! value-atom merge value))
                :filter-pred nil}
          options)
        nil value-atom]
       [:div.u-margin-top--xs
        [:button.c-round-button.u-margin-left--xs {:on-click
                  (util/handler
                    (fn []
                      (reset! edit-atom nil)
                      (update-disposition-choices! (:dispositions-atom options) original-value)
                      (some-> (:cancel-cb options) (apply []))))}
         "⟲"]
        [:button.c-round-button.u-margin-left--xs {:on-click
                  (util/handler
                    (fn []
                      (some-> (:on-save options) (apply [@value-atom]))))}
         "✓"]
        (when-not (nil? original-value)
          [:button.c-round-button.u-margin-left--xs {:on-click
                    (util/handler
                      (fn []
                        (when (js/confirm "Are you sure you want to unassign this disposition?")
                          (some-> (:on-delete options) (apply [@value-atom])))))}
           "×"])]])))

(defn disposition-list [{:keys [allow-edit context-key] :as options} collection-id dispositions]
  (let [edit (or (:edit-atom options) (atom nil))
        edit-key #(str context-key "-" %)
        edit-state? #(= (edit-key %) @edit)
        set-edit-state! (fn [disposition-key] (if (nil? disposition-key)
                                                (reset! edit nil)
                                                (reset! edit (edit-key disposition-key))))
        disposition-atoms (atom nil)
        new-value-atom (atom nil)
        errors (atom nil)
        dispositions-filter (fn [index disposition]
                              (not (contains? (set (map (comp :id deref) (util/vec-remove @disposition-atoms index))) (:id disposition))))
        save-fn (fn [disposition-atoms]
                  (->>
                    (api/ajaxp (str "/collection/" collection-id "/disposition/")
                      {:method :post
                       :format (json-request-format)
                       :params (util/remove-nil-values
                                 {:disposition
                                  (automation-model/dispositions-upsert-info
                                    (conj disposition-atoms new-value-atom)) })})
                    (p/map (fn [_]
                             (reset! edit nil)
                             (reset! new-value-atom nil)
                             (some-> (:list-change-cb options) (apply []))))
                    (process-error errors)))]
    (fn [options collection-id dispositions]
      (reset! disposition-atoms (chooser-disposition-value-atoms dispositions))
      [:div
       [:ul.c-disposition-list (when allow-edit {:class :editable})
        (doall
          (map-indexed
            (fn [index disposition]
              (let [disposition-id (:id disposition)]
                (if (edit-state? disposition-id)
                  ^{:key disposition-id} [disposition-list-manager
                                          (merge {:edit-atom edit
                                                  :on-save (partial save-fn @disposition-atoms)
                                                  :on-delete #(save-fn (util/vec-remove @disposition-atoms index))
                                                  :filter-pred (fn [disposition]
                                                                 (not (contains? (set (map (comp :id deref) (util/vec-remove @disposition-atoms index))) (:id disposition))))}
                                            options)
                                          (nth @disposition-atoms index)]
                  [:li (merge
                         {:key disposition-id}
                         (when allow-edit
                           {:on-click (util/handler #(set-edit-state! disposition-id))})) [disposition-name disposition]])))
            dispositions))
        (when (and allow-edit
                (or (edit-state? :new) (nil? @edit)))
          (if (edit-state? :new)
            [disposition-list-manager
             (merge {:edit-atom edit
                     :on-save (partial save-fn @disposition-atoms)
                     :filter-pred (fn [disposition]
                                    (not (contains? (set (map (comp :id deref) @disposition-atoms)) (:id disposition))))
                     :cancel-cb #(reset! new-value-atom nil)} options)
             new-value-atom]
            [:li.c-disposition-new {:key :new
                                    :on-click (util/handler #(set-edit-state! :new))}
             [:button.c-round-button "+"]]))]
       [:span.error (:disposition @errors)]])))

(defn- delete-report-modal [collection-id review-id on-delete]
  [:div.c-saved-reports__confirm
   [:p "Are you sure you want to delete Collection Analysis Report?"]
   [:div.c-saved-reports__confirm-actions
    [:button.c-button
     {:on-click (util/handler #(common/hide-modal :delete-report))}
     "Cancel"]
    [:button.c-button.c-button--danger
     {:on-click (util/handler
                 #(do
                    (controller/dispatch :collection-review :delete-report
                                         {:collection-id collection-id
                                          :review-id     review-id
                                          :on-success    on-delete})
                    (common/hide-modal :delete-report)))} "Delete"]]])

(defn confirm-discard-review
  "Asks before discarding an in-progress review; saved reports are not affected.
  *discarding is true while the request runs; on-success receives the review's
  collection id."
  [review-id *discarding on-success]
  (common/show-confirmation-modal
   {:title "Discard review"
    :text  "Are you sure you want to discard this review? All unsaved findings, resolutions, exceptions, and severity adjustments will be lost. The AARK™ chat stays, and AARK™ can start a new review there."
    :ok-cb #(do
              (reset! *discarding true)
              (controller/dispatch :collection-review :discard
                                   {:review-id  review-id
                                    :on-success (fn [collection-id]
                                                  (reset! *discarding false)
                                                  (on-success collection-id))
                                    :on-error   (fn [] (reset! *discarding false))}))}))

(defn saved-reports-sidebar [collection]
  (let [collapsed?   (atom false)
        show-all?    (atom false)
        *reviews     (atom (:reviews collection))]
    (fn [collection]
      (let [all-saved     (filter #(= (:status %) "saved") @*reviews)
            total         (count all-saved)
            saved-reports (if @show-all? all-saved (take 5 all-saved))]
        (when (seq all-saved)
          [:div.c-saved-reports
         [:h3.u-margin-bottom.u-border-bottom.o-collapsable.u-flex.c-segment-header
          {:class (when @collapsed? "is-collapsed")}
          [:span.c-segment-label "Collection Analysis Reports"]
          [:a.o-collapsable__expander {:on-click (util/handler #(swap! collapsed? not))}]]
         (when-not @collapsed?
           [:div
            [:ul
             (doall
              (for [report saved-reports]
                [:li.c-saved-reports__item {:key (:id report)}
                 [:b (str (util/date-reformat (or (:saved_at report) (:created_at report)) util/date-format-full-year) ":") " "]
                 (if (:has_report report)
                   [common/pdf-download-button
                    {:ajax-url         (str "/collection/" (:id collection) "/review/" (:id report) "/report")
                     :temp-url-ajax-url (str "/collection/" (:id collection) "/review/" (:id report) "/report-url")
                     :component        :a.c-saved-reports__link
                     :open-new-tab     true}
                    (or (:report_filename report) "Report")]
                   [:span.c-saved-reports__link.is-disabled
                    (or (:report_filename report) "Report")])
                 (when (auth-model/is-user-family-admin (:group_id collection))
                   [:a.c-saved-reports__delete.u-margin-left--xs.u-color--danger-red
                    {:href "#"
                     :on-click (fn [ev]
                                 (.preventDefault ev)
                                 (let [scroll-top (.-scrollTop js/document.documentElement)
                                       x          (- (.-clientX ev) 420)
                                       y          (- (.-clientY ev) 70)
                                       on-delete  (fn [] 
                                                    (swap! *reviews (fn [rs] 
                                                                      (vec (remove #(= (:id %) (:id report)) rs)))))]
                                   (common/show-modal :delete-report
                                                      [delete-report-modal (:id collection) (:id report) on-delete]
                                                      {:modal-class "modal-alert"
                                                       :scroll-top  scroll-top
                                                       :x           x
                                                       :y           y})))}
                    "×"])]))]
            (when (> total 5)
              [:a.c-saved-reports__toggle {:href "#" :on-click (util/handler #(swap! show-all? not))}
               (if @show-all? "View Less" "View All")])])])))))

(defn dispositions-sidebar-editable [collection collection-dispositions-atom]
  (let [dispositions-atom (chooser-dispositions-atom)
        labels-atom (chooser-labels-atom)
        disposition-edit-atom (atom nil)
        load-dispositions #(controller/dispatch :automation-dispositions :load {:family-id (:group_id collection)})
        load-labels #(controller/dispatch :label-list :load {:family-id (:group_id collection)
                                                             :object-type admin-model/object-type-disposition})]
    (load-dispositions)
    (load-labels)
    (fn []
      [disposition-list
       {:allow-edit true
        :edit-atom disposition-edit-atom
        :dispositions-atom dispositions-atom
        :labels-atom labels-atom
        :list-change-cb (fn []
                          (->>
                            (model/collection-full-details (:id collection))
                            (p/map (fn [collection]
                                     (reset! collection-dispositions-atom (:dispositions collection))))
                            (process-error))
                          (load-dispositions)
                          (load-labels))}
       (:id collection) @collection-dispositions-atom])))

(defn dispositions-sidebar [collection collection-dispositions-atom]
  [:div
   [:h3.u-margin-bottom.u-border-bottom "Dispositions"]
   (when-not (seq @collection-dispositions-atom)
     [:p "No dispositions assigned"])
   (if (auth-model/is-user-family-admin (:group_id collection))
     [dispositions-sidebar-editable collection collection-dispositions-atom]
     [disposition-list nil (:id collection) @collection-dispositions-atom])])

(defn boir-xml-bt [key collection-id]
  (fn [key collection-id]
    (when key
      [:div.dropdown
       [:form
        {:method :post
         :action (str "/download/boir_xml/")}
        [:input
         {:type  :hidden
          :name  :key
          :value key}]
        [:input
         {:type  :hidden
          :name  :collection_id
          :value collection-id}]
        [:span.controls [:button "Boir"]]]])))

(defn lifecycle-plan-line
  "Names the Lifecycle Management Plan governing this collection, next to the
  created date (#2985)."
  [collection]
  (when-let [plan (:lifecycle_plan collection)]
    (let [found? (:found plan)]
      [:p.c-collection-lifecycle-plan
       [:a.c-collection-lifecycle-plan__link
        {:href (str "#/chat?collection_id=" (:id collection))
         :title "Ask AARK about this collection"}
        [:img.c-collection-lifecycle-plan__icon {:src "/static/img/icons/aark-green.svg" :alt ""}]
        [:span.c-collection-lifecycle-plan__name {:class (when-not found? "is-missing")}
         (if found?
           (str (:name plan) " (v" (:version plan) ")")
           "No Lifecycle Management Plan for this subtype")]]])))

(defn collection-details [collection ancestor-list permitted-users]
  (let [family (first ancestor-list)
        document-tabs-active (atom :documents)
        dispositions (atom (:dispositions collection))
        task-tabs-active (atom :all)
        all-filter-show (atom false)
        task-filter-show (atom false)
        compliance-filter-show (atom false)
        compliance-bulk-edit (atom nil)
        show-steps (atom false)
        chosen-tasks (atom #{})
        select-all (atom false)
        signatures-filter-show (atom false)
        event-filter-show (atom false)
        report-mode (atom false)
        ;; Local copy so a discarded draft drops out of the header without a reload.
        reviews (atom (:reviews collection))
        discarding-review (atom false)
        e-boir-filter-show (model/has-boir-efile-enabled (:group_id collection))
        collection-chart-enabled (and (model/has-collection-chart-enabled (:id family)) (has-family-perm (:id family) :can_view_collection_chart))
        form-def (subscribe :collection-type-form-def)
        num-visible-segments (track! (fn [] (count (filter-form-data (:forms @form-def) collection))))
        document-filter-show (atom false)
        tab-with-closed-filter? (fn []
                                  (every? not
                                          [(and @compliance-filter-show (= @task-tabs-active :compliance))
                                           (and @task-filter-show (= @task-tabs-active :tasks))
                                           (and @signatures-filter-show (= @task-tabs-active :signatures))
                                           (and @event-filter-show (= @task-tabs-active :events))
                                           (and @document-filter-show (= @document-tabs-active :documents))]))
        collection-review-enabled (and
                                   (not (model/is-group collection))                                   
                                   (model/has-collection-review-enabled (:id family))
                                   (has-family-perm (:id family) :can_review_collection))]

    (add-watch report-mode :report-mode-filter-show
               (fn [_ _ oldv newv]
                 (when (and (not= oldv newv) newv)
                   (reset! compliance-filter-show true)
                   (reset! task-filter-show true))))
    
    (reagent/create-class

     {:display-name "collection-details"

      :component-did-mount (fn [_]
                             (reset! state/force-mobile-menu true)
                             (swap! state/menu-modal assoc :enabled false)
                             (.removeClass (js/$ "div.menu") "menu-on")
                             (.removeClass (js/$ "div.hamburger") "is-active"))

      :component-will-unmount #(reset! state/force-mobile-menu false)

      :reagent-render (fn [& args]
                        [:div.redesign
                         [header
                          :supertitle (when (> (count ancestor-list) 1) [breadcrumb ancestor-list false])
                          :title (collection-name collection)
                          :aside-title "workspace"
                          :subsubtitle [:p.u-font-size--larger (str (get-in collection [:collection_type :asset_type :name]) ": " (get-in collection [:collection_type :name]))]
                          :controls [toolbar [(perm :can_view_collection_details
                                                    (when (tab-with-closed-filter?) [details-switch [compliance-filter-show 
                                                                                                     task-filter-show 
                                                                                                     signatures-filter-show 
                                                                                                     event-filter-show
                                                                                                     document-filter-show]]))
                                              [toolbar-item "Subcollections" @state/include-descendants (util/handler #(swap! state/include-descendants not))]]]
                          :review-button (when collection-review-enabled
                                           (let [latest-review (first @reviews)
                                                 review-status  (:status latest-review)]
                                             [:div.c-header__review-button__row
                                              (cond
                                                (= review-status "in_progress")
                                                [:div {:on-click (util/handler
                                                                   #(controller/dispatch :collection-review :start {:collection-id (:id collection)
                                                                                                                    :review-id     (:id latest-review)}))}
                                                 [:img {:src "/static/img/icons/review_draft.svg"
                                                        :alt "See Review Draft"}]]

                                                :else
                                                [:div {:on-click (util/handler
                                                                   #(controller/dispatch :collection-review :start {:collection-id (:id collection)}))}
                                                 [:img {:src "/static/img/icons/review_collection.svg"
                                                        :alt "Review Collection"}]])
                                              [help-popover
                                               [:<>
                                                [:p [:strong "What is a Collection Review?"]]
                                                [:p "A preliminary review of this collection. AARK™ compares the documents, data, and compliance items against the Lifecycle Management Plan™ and your prior reviews, then surfaces what may need your attention. You confirm what each finding means. Your decisions carry forward, so future reviews don't re-surface what you've already resolved."]]
                                               {:align :right :size :xs}]
                                              (when (= review-status "in_progress")
                                                [:p.last-review (str "Review started: " (util/date-reformat (:created_at latest-review)))])
                                              (when (= review-status "in_progress")
                                                [:div.c-header__review-button__discard
                                                 [util/disable-tool
                                                  {:disabled  @discarding-review
                                                   :class     :u-non-clickable
                                                   :component [:button.c-button--small.c-button--danger
                                                               {:on-click (util/handler
                                                                           #(confirm-discard-review
                                                                             (:id latest-review) discarding-review
                                                                             (fn [_] (swap! reviews (fn [rs] (vec (remove (fn [rv] (= (:id rv) (:id latest-review))) rs)))))))}
                                                               "Discard draft"]}]])
                                              (when (and (not= review-status "in_progress") (:saved_at latest-review))
                                                [:p.last-review (str "Last review: " (util/date-reformat (:saved_at latest-review)))])]))]
                         
                         [:section.o-main-aside
                          [:main
                           [:div
                            [tabs-header-and-content
                             [tabs-header
                              (case @task-tabs-active
                                :all [:div.tab-controls.o-margin-elements--medium
                                      [collection-service-item-add (:id family) (:id collection)]
                                      [collection-service-filter-list task-tabs-active  task-filter-show compliance-filter-show event-filter-show ]]
                                :tasks [:div.tab-controls.o-margin-elements--medium
                                        [collection-service-item-add (:id family) (:id collection)]
                                        [task/report-mode-button {:filter-collection-id-atom (atom (or (:id collection) false))} report-mode]
                                        [:button {:on-click (util/handler #(swap! task-filter-show not))} "Filter"]]
                                :compliance [compliance-controls family collection compliance-filter-show compliance-bulk-edit report-mode {:show-steps-atom show-steps
                                                                                                                                            :chosen-tasks-atom chosen-tasks
                                                                                                                                            :select-all-atom select-all}]
                                :signatures [:div.tab-controls.o-margin-elements--medium
                                             [:button {:on-click (util/handler #(swap! signatures-filter-show not))} "Filter"]]
                                :events [:div.tab-controls.o-margin-elements--medium
                                         [collection-service-item-add (:id family) (:id collection)]
                                         [:button {:on-click (util/handler #(swap! event-filter-show not))} "Filter"]])
                              [tab-header {:tab-id :all
                                           :active-atom task-tabs-active} [:span [:img.tab-header {:src "/static/img/icons/all.svg"}] [:span.name "All"]]]
                              [tab-header {:tab-id :tasks
                                           :active-atom task-tabs-active} [:span [:img.tab-header.task {:src "/static/img/icons/task-blue.svg"}] [:span.name "Tasks"]]]
                              [tab-header {:tab-id :compliance
                                           :active-atom task-tabs-active} [:span [:img.tab-header {:src "/static/img/icons/compliance-blue.svg"}] [:span.name "Compliance"]]]
                              [tab-header {:tab-id :signatures
                                           :active-atom task-tabs-active} [:span [:img.tab-header {:src "/static/img/icons/signature.svg"}] [:span.name "Signatures"]]]
                              [tab-header {:tab-id :events
                                           :active-atom task-tabs-active} [:span {:on-click (fn [_]
                                                                                              (js/setTimeout (fn []
                                                                                                               (.click (js/$ ".calendar-previous"))
                                                                                                               (.click (js/$ ".calendar-next"))) 1000))}
                                                                           [:img.tab-header {:src "/static/img/icons/event-blue.svg"}] [:span.name "Events"]]]]
                             (case @task-tabs-active
                               :all [:div.t-table-redesign {:key :all} [pfo.task.component/common-task-list {} (:id collection) nil all-filter-show]]
                               :tasks [:div.t-table-redesign {:key :tasks} [pfo.task.component/task-list {:bulk-edit-atom (atom nil)
                                                                                                          :e-boir-filter-show e-boir-filter-show
                                                                                                          :report-mode-atom report-mode} (:id collection) nil "simple" task-filter-show]]
                               :compliance [:div.t-table-redesign {:key :compliance} [pfo.task.component/task-list
                                                                                      {:bulk-edit-atom compliance-bulk-edit
                                                                                       :show-steps-atom show-steps
                                                                                       :chosen-tasks-atom chosen-tasks
                                                                                       :select-all-atom select-all
                                                                                       :report-mode-atom report-mode}
                                                                                      (:id collection) nil "compliance" compliance-filter-show]]
                               :signatures [:div.t-table-redesign {:key :signatures} [pfo.task.component/task-list {:signature false
                                                                                                                    :signatures true
                                                                                                                    :bulk-edit-atom (atom nil)} (:id collection) nil "all" signatures-filter-show]]
                               :events [:div.t-table-redesign {:key :events} [task/event-list (:id collection) nil event-filter-show true]])]]

                           [:div.o-main-aside__row._tabs
                            [tabs
                             (tab
                              [:span [:img.tab-header {:src "/static/img/icons/document-blue.svg"}] [:span.name "Document Library"]]
                              :documents
                              document-tabs-active
                              [:div.t-table-redesign [document/document-list {} (:id collection) nil document-filter-show]]
                              [document/document-list-buttons (:id collection) document-filter-show (has-family-perm (:id family) :can_add_document)])
                             (tab
                              [:span [:img.tab-header {:src "/static/img/icons/activity-recent.svg"}] [:span.name "Recent Activity"]]
                              :activity
                              document-tabs-active
                              [:div.t-table-redesign [activity/collection-activity {:collection-id (:id collection)}]]
                              nil)]]]


                          (when (and @state/sidebar-active (tab-with-closed-filter?))
                            [sidebar
                             [collection-coltype-details
                              {:first-segment-header-extra-content (when (and collection-chart-enabled (model/can-be-chart-subject? collection))
                                                                     [:button.c-form-segment-button.c-button--small
                                                                      {:on-click #(util/set-location
                                                                                   (path-for :collection-charts :id (:id collection)))}
                                                                      "Chart"])}
                              collection]
                             (when (model/has-document-automation-enabled (:group_id collection))
                               [dispositions-sidebar collection dispositions])
                             (when (and collection-review-enabled
                                        (seq (filter #(= (:status %) "saved") (:reviews collection))))
                               [saved-reports-sidebar collection])
                             [:p [:span.label "Permitted users: "] (clojure.string/join ", " (mapv auth-model/get-full-name permitted-users))] 
                             [:footer
                              (when (auth-model/is-user-family-admin (:group_id collection))
                                [:span
                                 (if (not= "gr" (:type collection))
                                   [:span
                                    [:button {:on-click #(util/set-location (str "#/admin/collection/edit/" (:id collection) "/"))} "Edit"] " "
                                    (when-not (or (:has_data collection) (:has_subcollections collection))
                                      [:button {:on-click (fn [_]
                                                            (when (js/confirm "Are you sure you want to permanently delete this collection?")
                                                              (->> (admin-model/group-admin-collection-delete (:id collection))
                                                                   (p/map (fn [_]
                                                                            (set-flash :success "Collection deleted")
                                                                            (util/set-location (str "#/collection/details/" (:parent_id collection)))))
                                                                   (p/error (fn [error-response]
                                                                              (if (and
                                                                                   (= 400 (:status error-response))
                                                                                   (= "is_owner" (get-in error-response [:response :body :type])))
                                                                                (set-flash :error [:span "Can't delete collection used in an ownership: "
                                                                                                   (doall
                                                                                                    (for [col (get-in error-response [:response :body :data])]
                                                                                                      [:span [:a {:href (path-for :collection-details :id (:id col))} (:name col)] " "]))])

                                                                                (throw error-response))))
                                                                   (process-error))))} "Delete"]) " "]
                                   [:span [:button {:on-click #(util/set-location (str "#/admin/collection/details/edit/" (:id collection) "/"))} "Edit details"] " "])
                                 [:button {:on-click #(util/set-location (str "#/admin/collection/add/?parent_id=" (:id collection)))} "Add subcollection"] " "
                                 (when (and (zero? @num-visible-segments) collection-chart-enabled (:collection_type collection) (model/can-be-chart-subject? collection))
                                   [:span
                                    [:button {:on-click #(util/set-location (path-for :collection-charts :id (:id collection)))} "Chart"] " "])])
                              (when (and (model/is-boir-collection collection)
                                         (model/has-boir-efile-enabled (:group_id collection)) 
                                         (auth-model/has-perm :can_view_collection_details) 
                                         (auth-model/has-perm :can_add_document))
                                [:button {:on-click #(util/set-location (path-for :collection-boir-preview :id (:id collection)))} "Generate BOIR"])
                              [:p [:b "Created: " (util/date-reformat (:created_at collection))]]
                              [lifecycle-plan-line collection]]])]])})))

(defn toggle-panel [event]
  (dorun (->>
           (sel ".sliding-panel-content,.sliding-panel-fade-screen")
           (map #(dommy/toggle-class! % :is-visible))))
  (.preventDefault event))


(add-watch
  state/recent-parent-ids
  :nav-reloader
  (fn [_ _ _ recent-parent-ids]
    (let [child-id-map (clojure.core/atom {})]
      (doall (for [[parent-id child-id] (partition 2 1 recent-parent-ids)]
               (->> (model/collection-list-promise parent-id true)
                 (p/map (fn [response]
                          (swap! child-id-map merge (into {} (mapv (fn [child] [(:id child) child]) response)))
                          (swap! state/recent-selected-child assoc parent-id (@child-id-map child-id))
                          (swap! state/recent-parent-children assoc parent-id response)))))))
    (swap! state/parent-id-filter-map
      (fn [old-parent-id-filter-map]
        (into {}
          (map (fn [parent-id]
                 [parent-id (or
                              (old-parent-id-filter-map parent-id)
                              (spy :debug
                                (str "Setting default filter for collection id " parent-id)
                                collection-default-filter))])
            recent-parent-ids))))))

(defn set-selected-children [current-value current-parent-ids new-parent-id new-child]
  (let [current-parent-ids (into #{} current-parent-ids)]
    (let [result (assoc (into {} (filter (fn [[parent-id child]] (contains? current-parent-ids parent-id)) current-value)) new-parent-id new-child)]
      result)))

(def collection-default-filter
  {:active :active
   :name ""
   :collection-type-id nil})

(defn normalize-colleciton-filter [cfilter]
  (merge cfilter
    (when (< (count (:name cfilter)) 3) {:name ""})))

(defn collection-filter-is-default [cfilter]
  (= cfilter (normalize-colleciton-filter collection-default-filter)))

(defn collection-filter-state-abbrev [cfilter collection-type-id-map]
  (let [cfilter (normalize-colleciton-filter cfilter)
        has-name (seq (:name cfilter))
        has-ct (boolean (:collection-type-id cfilter))]
    (if (collection-filter-is-default cfilter)
    "default"
    (str/join "; "
      (filter identity
        [(case (:active cfilter)
           :active "active"
           :inactive "inactive"
           :all "active & inactive")
         (when has-name (str "name contains \"" (:name cfilter) "\""))
         (when has-ct
           (str "collection type: \""
             (coltype-model/collection-type-name (collection-type-id-map (:collection-type-id cfilter)))
             "\""))])))))

(defn apply-collection-filter [cfilter collections]
  (let [cfilter (normalize-colleciton-filter cfilter)]
    (filter (fn [col]
              (or (nil? cfilter)
                (and
                  (case (:active cfilter)
                    :active (:active col)
                    :inactive (not (:active col))
                    true)
                  (condp = (:name cfilter)
                    "" true
                    (str/includes? (str/lower-case (:name col)) (str/lower-case (:name cfilter))))
                  (condp = (:collection-type-id cfilter)
                    nil true
                    (= (:collection_type_id col) (:collection-type-id cfilter)))))) collections)))

(defn collection-type-chooser-autocomplete [_ _ _ changed-cb]
  (fn [_ collection-types value _]
    (let [ct-map (util/associate-by :id collection-types)
          selected-ct-value (when value {:label (coltype-model/collection-type-name (ct-map value)) :value value})
          control-height "2.5em"]
      [:> Select
       (merge
         {:options     (map (fn [ct] {:label (coltype-model/collection-type-name ct)  :value (:id ct)}) collection-types)
          :placeholder "Choose collection type"
          :value       selected-ct-value
          :on-change   (fn [e]
                         (changed-cb (:value (js->clj e :keywordize-keys true))))

          :filterOption (createFilter (clj->js {:ignoreAccents false}))
          :styles {:control (fn [provided _]
                              (j/assoc! provided
                                :backgroundColor "#2b496d"
                                :borderColor "#00ffbe"
                                :minHeight control-height
                                :height control-height
                                :fontSize "0.95em"))
                   :valueContainer (fn [provided _]
                                     (j/assoc! provided
                                       :height control-height
                                       :paddingLeft "0.3em"))
                   :indicatorsContainer (fn [provided _]
                                          (j/assoc! provided
                                            :height control-height))
                   :indicatorSeparator (fn [provided _]
                                         (j/assoc! provided
                                           :display "none"))
                   :dropdownIndicator (fn [provided _]
                                        (j/assoc! provided
                                          :color "rgb(79,168,153)"))
                   :placeholder (fn [provided _]
                                  (j/assoc! provided
                                    :color "rgb(79,168,153)"
                                    :textOverflow "ellipsis"
                                    :whiteSpace "nowrap"))
                   :option (fn [provided state]
                             (j/assoc! provided
                               :backgroundColor (if (j/get state "isFocused") "#487ab6" "#2b496d")))
                   :menuList (fn [provided _]
                               (j/assoc! provided
                                 :background "#2b496d"
                                 :border "1px solid #00ffbe"))}
          :theme primary-theme})])))

(defn x-button [{:keys [style on-click]}]
  [:button.c-round-button
   {:style    (merge {:margin "0.5em 0.5em" :box-shadow nil} style)
    :on-click (util/handler on-click)}
   "×"])

(defn collection-filter [_ _ parent-id-collapsed-map-atom _ _]
  (fn [options parent-id-filter-map-atom _ parent-id collection-types]
    (let [get-filter #(@parent-id-filter-map-atom parent-id collection-default-filter)
          get-filter-value #(get-in @parent-id-filter-map-atom [parent-id %])
          is-filter (fn [fkey value] (= (get-filter-value fkey) value))
          set-filter (fn [fkey value]
                       (swap! parent-id-filter-map-atom update parent-id
                         (fn [old-value] (merge collection-default-filter old-value {fkey value}))))
          is-collapsed #(@parent-id-collapsed-map-atom parent-id)
          set-collapsed (fn [collapsed?] (swap! parent-id-collapsed-map-atom assoc parent-id collapsed?))
          collection-type-id-map (util/associate-by :id collection-types)]

      [:div.c-collection-filter
       {:class (if (is-collapsed)
                 "c-collection-filter--collapsed"
                 "c-collection-filter--expanded")}
       [:a {:href "#"
            :on-click (util/handler (fn[] (set-collapsed (not (is-collapsed)))))}
        [:div.o-collapsable.u-flex {:class (when (is-collapsed) "is-collapsed")}
         (if (is-collapsed)
           [:span "Filter: " [:em (collection-filter-state-abbrev (get-filter) collection-type-id-map)]]
           [:span "Filter"])
         [:a.o-collapsable__expander]]]
       (when-not (is-collapsed)
         [:div
          [:div
           [:label [:input
                    (set-checked
                      (is-filter :active :active)
                      {:type :checkbox
                       :on-change #(set-filter :active :active)})] " Active"]
           [:label [:input
                    (set-checked
                      (is-filter :active :inactive)
                      {:type :checkbox
                       :on-change #(set-filter :active :inactive)})] " Inactive"]
           [:label [:input
                    (set-checked
                      (is-filter :active :all)
                      {:type :checkbox
                       :on-change #(set-filter :active :all)})] " All"]]
          [:div.cancelable-control
           [collection-type-chooser-autocomplete options collection-types
            (get-filter-value :collection-type-id)
            (fn [new-collection-type-id]
              (set-filter :collection-type-id new-collection-type-id))]
           [x-button {:on-click (fn [] (set-filter :collection-type-id nil))}]]
          [:div.cancelable-control
           [:div [:input {:type :text
                          :placeholder "Type collection name"
                          :value (get-filter-value :name)
                          :on-change (fn [ev] (set-filter :name (event-value ev)))}]]
           [x-button {:on-click (fn [] (set-filter :name ""))}]] ])])))

(defn get-family-id [parent-ids]
  (second parent-ids))

(defn collection-nav2 []
  (let [parent-ids (atom @state/recent-parent-ids)
        parent-children state/recent-parent-children
        parent-id-filter-map state/parent-id-filter-map
        parent-id-collapsed-map (atom (into {} (map (fn [parent-id] [parent-id true]) @parent-ids)))
        selected-child state/recent-selected-child
        load-children (fn [parent-id]
                        (swap! parent-id-collapsed-map assoc parent-id true)
                        (swap! parent-id-filter-map update parent-id (fn [old-filter]
                                                                       (if old-filter
                                                                         old-filter
                                                                         collection-default-filter)))
                        (->> (model/collection-list-promise parent-id true)
                          (p/map (fn [response]
                                   (swap! parent-children assoc parent-id response)))
                          (process-error)))
        collection-types (atom nil)
        global-collection-types (atom nil)
        load-collection-types (fn [family-id]
                                (->>
                                  (coltype-model/collection-types family-id nil)
                                  (p/map #(reset! collection-types %))
                                  (process-error)))
        load-global-collection-types (fn []
                                       (->>
                                         (coltype-model/collection-types nil nil)
                                         (p/map #(reset! global-collection-types %))
                                         (process-error)))
        go-to (fn [url]
                (reset! state/ui-state {})
                (util/set-location url)
                (reset! state/display-collection-nav false))
        go-to-collection (fn [collection-id]
                           (go-to (str "#/collection/details/" collection-id)))]
    (when-not (@parent-children nil)
      (load-children nil))
    (load-global-collection-types)
    (add-watch parent-ids :family-ctypes
      (fn [_ _ old-pids new-pids]
        (when-not (= (second old-pids) (second new-pids))
          (load-collection-types (second new-pids)))))
    (when-let [family-id (get-family-id @parent-ids)]
      (load-collection-types family-id))

    (fn []
      [:div.collection-nav
       [:div.content
        (doall
          (take-last 4
            (map-indexed
              (fn [index {:keys [parent-id filtered-children all-children]}]
                (let [children filtered-children
                      all-children-coltype-ids (set (map :collection_type_id all-children))]
                  [:div.column {:key index}
                   (when children
                     (let [selected (@selected-child parent-id)]
                       [:div.selected {:on-click #(go-to-collection (:id selected))
                                       :class (if-not selected "hidden" "")}
                        (or (:name selected) (util/entity "&nbsp;")) ]))
                   [collection-filter nil  parent-id-filter-map parent-id-collapsed-map parent-id
                    (filter (fn [ct] (contains? all-children-coltype-ids (:id ct))) (if parent-id
                                                                                      @collection-types
                                                                                      @global-collection-types))]

                   (when children
                     (let [col-type-name (fn [col] (str (get-in col [:collection_type :asset_type :name]) "-" (get-in col [:collection_type :name])))
                           collection-types-by-name (into {} (mapv (fn [child] [(col-type-name child) (:collection_type child)]) children ) )
                           asset-types-by-name (into {} (mapv (fn [child] [(get-in child [:collection_type :asset_type :name]) (get-in child [:collection_type :asset_type])]) children))
                           grouped-children (util/ordered-group-by (fn [child] (col-type-name child)) children)
                           grouped-by-asset-type (util/ordered-group-by (fn [[group children]] (get-in (collection-types-by-name group) [:asset_type :name])) grouped-children)]

                       (doall
                         (for [[asset-type-name grouped-by-collection-type] grouped-by-asset-type]
                           (let [asset-type (asset-types-by-name asset-type-name)]
                             [:div {:key (:id asset-type)}
                              (when-let [asset-type-name (:name asset-type)]
                                [:p.grouper.asset asset-type-name])
                              (doall
                                (for [[group-name children] grouped-by-collection-type]
                                  (let [group (collection-types-by-name group-name)]
                                    [:div {:key (:id group)}
                                     (when-let [group-name (:name group)]
                                       [:p.grouper group-name])
                                     [:ul
                                      (doall
                                        (for [child children]
                                          (let [has-children (not (zero? (:child_count child)))
                                                chart-available (let [family-id (if (= "gr" (:type child))
                                                                                  (:id child) (get-family-id @parent-ids))]
                                                                  (and
                                                                    (model/has-collection-chart-enabled family-id)
                                                                    (model/can-be-chart-subject? child)
                                                                    (has-family-perm family-id :can_view_collection_chart)))]
                                            [:li.collection {:key (:id child)
                                                             :class (classes (if-not (:active child) "inactive" "")
                                                                      (when has-children "has-children"))}
                                             [:div.collection
                                              [:div.name  {:title (:name child)
                                                           :on-click (fn [_]
                                                                       (swap! selected-child set-selected-children @parent-ids parent-id child)
                                                                       (swap! parent-ids add-level-from-index index (:id child))
                                                                       (load-children (:id child))
                                                                       (.scrollTo js/window 0 0))
                                                           :class (when (and ;; for families, highlight only when more than one family for user
                                                                          (or (> (count (@parent-children parent-id)) 1) (> index 0))
                                                                          ;; matches selected
                                                                          (= (:id child) (:id (@selected-child parent-id)))) "is-selected")}
                                               (:name child) " " (when has-children [:span.collection-nav__arrow])]
                                              [:div.buttons
                                               (when (:permitted child)
                                                 [:div.button {:on-click #(go-to-collection (:id child))} "View"])
                                               (when chart-available
                                                 [:div.button {:on-click #(go-to (path-for :collection-charts :id (:id child)))} "Chart"])]]])))]])))])))))]))

              ;; take-until assures that we see all parents that have children until the first one that doesn't (considering the state of filters);
              ;; it includes that first empty one -- it's the level that we do filtering on.
              (util/take-until (fn [{:keys [selected-child-id filtered-children]}]

                                 ;; The last accepted is the one which does not contain the id of selected collection
                                 ;; on the children list -- it had been filtered out after selection
                                 (not (seq (filter #(= (:id %) selected-child-id)
                                             filtered-children ))))

                ;; Don't show a column if there's no children (without filtering)
                (filter #(seq (:all-children %))
                  ;; returns pairs [parent-id next-parent-id], which is equvalent to [parent-id child-id-selected-in-that-parent]
                 (map (fn [[parent-id selected-child-id]]
                       {:parent-id parent-id
                        :selected-child-id selected-child-id
                        :all-children (@parent-children parent-id)
                        :filtered-children (apply-collection-filter
                                             (@parent-id-filter-map parent-id)
                                             (@parent-children parent-id))})
                  (map vector @parent-ids (conj (vec (rest @parent-ids)) nil))))))))]])))

(defn add-level-from-index [parent-ids index new-parent-id]
  (conj (into [] (take (+ index 1) parent-ids)) new-parent-id))

(defn close-collection-nav [ev]
  (reset! state/display-collection-nav false)
  (reset! state/ui-state {}))

(defn collection-dispositions-edit [{:keys [change-cb]} collection disposition-atoms]
  (let [disposition-list-flat-atom (automation/chooser-dispositions-atom)
        label-list-flat-atom (automation/chooser-labels-atom)]
    (fn []
      [:div.c-field-inline-column
       (doall
         (map-indexed
           (fn [index disposition-atom]
             (let [disposition-id (:id @disposition-atom)]
               [:div.c-field-inline-column__field {:key (str index "-" disposition-id) :style {}}
                [:div {:style {:white-space :nowrap :position "relative"}}
                 (when (> (count @disposition-atoms) 1)
                   [:button.c-assignments-edit-button.c-round-button
                    {:style {:position :absolute :left "-2.5em" :top "0.2em"}
                     :on-click (util/handler
                                 (fn []
                                   (swap! disposition-atoms util/vec-remove index)))}
                    [:span "×"]])
                 [:div.u-width--full.c-collection-disposition-chooser {:style {:display "inline-block"}}
                  [automation/disposition-and-label-chooser
                   {:allow-empty true
                    :dispositions-atom disposition-list-flat-atom
                    :labels-atom label-list-flat-atom
                    :allow-create-new true
                    :change-cb (fn [value]
                                 (automation/update-disposition-choices! disposition-list-flat-atom value)
                                 (swap! disposition-atom merge value)
                                 (change-cb value))
                    :filter-pred (fn [disposition]
                                   (not (contains? (set (map (comp :id deref) (util/vec-remove @disposition-atoms index))) (:id disposition))))}
                   (:group_id collection) disposition-atom]]]]))
           @disposition-atoms))])))

;; family-id is needed when collection and parent-id are absent -- to fetch collection types
(defn collection-details-edit [{:keys [value-atoms]
                                :as options} collection parent-id family-id]
  (let [name (or (:name value-atoms) (atom (or (:fixed-name options) (:name collection))))
        collection-type (or (:collection-type-id value-atoms) (atom (:collection_type_id collection)))
        coltype (or (:coltype value-atoms) (atom nil))
        active (or (:active value-atoms) (atom (if collection (:active collection) true)))
        create-review (or (:create-review value-atoms) (atom false))
        disposition-atoms (atom [])
        dispositions-changed (atom false)
        allow-parent-choice (or (:allow-parent-choice options) (and collection (not (model/is-group collection))))
        parent (if-let [collection-parent-id (:parent_id collection)] (atom collection-parent-id) parent-id) 
        parent-name (or (:parent-name value-atoms) (atom nil))
        include-inactive-atom (atom false)
        collection-tree (atom {})

        errors (atom {})
        collection-types (atom nil)
        changed-forms (:forms-change-status-atom options)
        track-changes (clojure.core/atom true)
        setup-dispositions-atom! (fn [collection-data]
                                   (reset! track-changes false)
                                   (reset! disposition-atoms (automation/chooser-disposition-value-atoms (:dispositions collection-data)))
                                   (reset! track-changes true))


        load-parent (fn [parent-id]
                      (->> (model/collection-details parent-id)
                        (p/map (fn [response]
                                 (reset! parent (:id response))
                                 (reset! parent-name (:name response))))
                        (process-error)))

        load-collection-tree (fn []
                               (->> (model/collection-tree (or family-id (:group_id collection)) true @include-inactive-atom nil)
                                 (p/map (fn [response] (reset! collection-tree response)))
                                 (process-error)))

        load-collection-types (fn []
                                (let [limit-collection-types (boolean (seq (:collection-type-refs options)))
                                      ref-set (set (:collection-type-refs options))]
                                  (->>
                                    (if family-id
                                      (->> (coltype-model/collection-types family-id nil)
                                        (p/map
                                           (fn [response] 
                                             (reset! collection-types (if limit-collection-types
                                                                        (filter #(contains? ref-set (:ref %)) response)
                                                                        response))))
                                          (process-error))
                                     (->> (model/collection-details (or (:id collection) @parent-id))
                                          (p/map (fn [coldetails]
                                                   (->> (coltype-model/collection-types (:group_id coldetails) nil)
                                                        (p/map #(reset! collection-types %))
                                                        (process-error))))
                                          (process-error)))
                                   (p/map (fn [_]
                                            (when (and
                                                   (not @collection-type)
                                                   limit-collection-types)
                                              (let [initial-ct (first
                                                                (filter (fn [ct]
                                                                          (contains? ref-set (:ref ct)))
                                                                        @collection-types ))]
                                                (when initial-ct
                                                  (reset! collection-type (:id initial-ct)))))
                                            (when @collection-type
                                              (reset! coltype (first (filter #(= (:id %) (util/somestr-to-int @collection-type)) @collection-types)))))))))
        load-dispositions (fn []
                            (when (model/has-document-automation-enabled (:group_id collection))
                              (controller/dispatch :automation-dispositions :load {:family-id (:group_id collection)
                                                                                   :page nil
                                                                                   :order nil})))
        load-labels (fn []
                      (when (model/has-document-automation-enabled (:group_id collection))
                        (controller/dispatch :label-list :load {:family-id (:group_id collection)
                                                                :object-type admin-model/object-type-disposition
                                                                :page nil
                                                                :order nil})))]

    (setup-dispositions-atom! collection)
    (load-collection-types)
    (when (or parent-id collection) (load-parent @parent) )

    (when (and allow-parent-choice collection)
      (load-parent (:parent_id collection)))

    (when (or allow-parent-choice collection)
      (load-collection-tree))

    (doseq [aref [name collection-type active create-review dispositions-changed disposition-atoms]]
      (add-watch aref (str aref "-change-watch-details")
        (fn [& _]
          (when @track-changes (swap! changed-forms assoc :coltype-form-details true)))))
    (add-watch parent :parent-change-watch-details
      (fn [_ _ old-value new-value]
        (when (not= (str old-value) (str new-value)) (swap! changed-forms assoc :coltype-form-details true))))
    (add-watch include-inactive-atom :parent-edit-include-inactive
      (fn [& _]
        (load-collection-tree)))
    (load-dispositions)
    (load-labels)

    (fn [options collection _]
      [:section {:class (str "u-display--" (if (= (:active-form options) :details) "block" "none"))}
       (when-not (:hide-form-header options)
         [:h1.u-flex {:style {:height (str (:header-height options) "px")}} (or (:title options) "Details")])
       [:form 
        {:class (if (:form-class options) (:form-class options) "c-collection-template-roadmap__form o-margin-elements--lg-vertical")
         :on-submit (util/handler (fn []
                                    (let [submit-func (if collection
                                                        (partial (:update-func options) (:id collection))
                                                        (:add-func options))]
                                      (->> (submit-func (merge
                                                         {:name (or (:fixed-name options) @name)
                                                          :parent_id @parent
                                                          :collection_type_id (util/somestr-to-int @collection-type)
                                                          :active @active
                                                          :disposition (automation-model/dispositions-upsert-info @disposition-atoms)}

                                                         (when-not collection {:create_review @create-review})))
                                           (p/map (fn [response]
                                                    (if-let [success-cb (:success-cb options)]
                                                      (success-cb response)
                                                      (do
                                                        (->> (model/collection-full-details (:id response))
                                                             (p/map
                                                              (fn [response]
                                                                (some-> (:collection-atom-pre-change-cb options) (apply []))
                                                                (reset! (:collection-atom options) response)
                                                                (load-dispositions)
                                                                (load-labels)
                                                                (setup-dispositions-atom! response)))
                                                             (process-error))
                                                        (->> (model/collection-ancestors (:id response))
                                                             (p/map
                                                              (fn [response]
                                                                (reset! (:ancestor-list-atom options) response)))
                                                             (process-error))

                                                        (swap! changed-forms
                                                               assoc :coltype-form-details false)

                                                        (->> (model/collection-list-promise (:parent_id response) false)
                                                             (p/map #(swap! state/recent-parent-children assoc (:parent_id response) %))
                                                             (process-error))
                                                        (if collection
                                                          (do
                                                            (reset! errors {})
                                                            (set-flash :success "Details changed"))
                                                          (do
                                                            (set-flash :success "Collection saved")
                                                            (set-waypoint :collection-details :id (:id response))
                                                            (util/set-location (str "#/admin/collection/edit/" (:id response) "/?tab=permissions"))))))))
                                           (process-error errors)))))}
        [:div.c-field-inline
         [:label.c-field-inline__label "Name*"]
         [:input.c-field-inline__field (merge {:type "text"
                                               :value @name
                                               :on-change (util/reset-from-event name)}
                                              (when (:fixed-name options) {:disabled :disabled}))]
         [:span.error (:name @errors "")]]

        [:div.c-field-inline
         [:label.c-field-inline__label "Type*"]
         [:select.c-field-inline__field (merge
                                         {:on-change (fn [e]
                                                       (reset! collection-type (event-value e))
                                                       (reset! coltype (first (filter #(= (:id %) (util/somestr-to-int @collection-type)) @collection-types))))
                                          :value @collection-type}
                                         (when (or
                                                (:collection-type-ref options)
                                                (-> collection :data :entity)) ;; non-editable if in a collectionship
                                           {:disabled :disabled}))
          [:option "Choose Collection Type"]
          (doall
           (for [coltype @collection-types]
             [:option {:key (:id coltype)
                       :value (:id coltype)}
              (get-in coltype [:asset_type :name]) ": " (:name coltype)])) ]
         [:span.error (:collection_type_id @errors "")]]

        (when allow-parent-choice
          [:div
           [:div.c-field-inline
            [:label.c-field-inline__label "Parent* (type to search)"]
            [:span.c-field-inline__field [nav-search
                                          {:on-change (fn [e _]
                                                        (let [{:keys [value label]} (js->clj e :keywordize-keys true)]
                                                          (when value
                                                            (reset! parent value)
                                                            (reset! parent-name (or label "")))))

                                           :value #js {:listLabel (str @parent-name)
                                                       :label (str @parent-name)
                                                       :value (str @parent-name) }
                                           :placeholder "Type collection name"
                                           :parent-id (or family-id (:group_id collection))
                                           :include-inactive @include-inactive-atom}]]]
           [:button.c-field-inline__button {:href "#"
                                            :on-click (util/handler (fn []
                                                                      (reset!
                                                                       state/collection-tree-modal
                                                                       {:enabled true
                                                                        :current-id @parent
                                                                        :cb (fn [collection]
                                                                              (reset! parent (:id collection))
                                                                              (reset! parent-name (:name collection))
                                                                              (swap! state/collection-tree-modal assoc :enabled false))
                                                                        :on-save-cb (fn [_]
                                                                                      (when-let [collection-obj (some-> @state/collection-tree-modal :choosen-assignments first :collection-obj)]
                                                                                        (reset! parent (:value collection-obj))
                                                                                        (reset! parent-name (:label collection-obj))
                                                                                        (swap! state/collection-tree-modal assoc :enabled false)))
                                                                        :options {:single-choice true}
                                                                        :tree-items collection-tree
                                                                        :group-id (or family-id (:group_id collection))
                                                                        :include-inactive-atom include-inactive-atom})))}

            "or choose from tree"]
           [:span.error (:parent_id @errors "")]])
        (when (and (model/has-document-automation-enabled (:group_id collection))
                   (seq @disposition-atoms))
          [:div
           [:div.c-field-inline
            [:label.c-field-inline__label "Disposition and its label"]
            [collection-dispositions-edit
             {:change-cb #(swap! dispositions-changed not)}
             collection disposition-atoms]]
           (when (util/to-value @(last @disposition-atoms))
             [:button.c-field-inline__button {:on-click (util/handler
                                                         (fn []
                                                           (swap! disposition-atoms conj (atom nil))))} "Add new"])
           [:span.error (:disposition @errors "")]])


        (when-not (:hide-active options)
          [:div
           [:label [:input (form/set-checked @active {:on-click #(reset! active (form/checked? %))})] "Is Active?"]
           [:span.error (:active @errors "")]])
        (when-not collection
          [:div
           [:label [:input (form/set-checked @create-review {:on-click #(reset! create-review (form/checked? %))})] "Create Review compliance"]
           [:span.error (:create_review @errors "")]])
        (when-not (:disable-save options)
          [:button.o-flex-align--element-to-right
           (when-not (:coltype-form-details @changed-forms) {:disabled :disabled})
           (if collection
             (or (:save-existing-button-title options) "Save")
             (or (:save-new-button-title options) "Continue"))])]])))

(defn boir-add-document-button [_ _ filing-type-atom]
  (let [show-menu (atom false)
        ref       (atom nil)]
    (reagent/create-class
      {:component-did-mount #(-> (js/$ "div.outer-container")
                               (.click
                                 (fn [e]
                                   (when-not (= (-> e .-target) @ref)
                                     (reset! show-menu false)
                                     (-> (js/$ "ul.dropdown-menu.dropdown-select") (.removeClass "show"))))))
      :reagent-render      (fn [_ operation-uid _]
                             (let [add-fn (fn [filing-type]
                             (print "Fun call")
                                            (controller/dispatch :boir-document :add
                                                                 [{:on-success (fn [document]
                                                                                 (set-flash :success (str "BOIR document added." " " (:message document)))
                                                                                 (util/set-location (path-for :document-details :id (:id document))))}
                                                                  {:operation_uid operation-uid
                                                                   :filing_type filing-type
                                                                   :task_id (:task_id (util/get-location-params))}]))]
                               [:div.dropdown.c-actions {:style {:display :inline} :key :add}
                                [:div.dropdown-container

                                  [:span
                                   [:button
                                    {:ref (fn [com] (reset! ref com)) :on-click (util/handler #(add-fn @filing-type-atom))}
                                    "Add Document"]] ]]))})))


(defn boir-file-document-button [options _ filing-type-atom]
  (let [show-menu (atom false)
        ref       (atom nil)
        file-with-errors-enabled? js/FINCEN_API_FILE_WITH_ERRORS]
    (reagent/create-class
      {:component-did-mount #(-> (js/$ "div.outer-container")
                               (.click
                                 (fn [e]
                                   (when-not (= (-> e .-target) @ref)
                                     (reset! show-menu false)
                                     (-> (js/$ "ul.dropdown-menu.dropdown-select") (.removeClass "show"))))))
       :reagent-render      (fn [options operation-uid _]
                              (let [add-fn (fn [filing-type]
                                             (controller/dispatch :boir-document :file
                                               [{:on-success (fn [file-response]
                                                               (some-> (:success-cb options) (apply [file-response])))
                                                 :on-error (fn [e] (some-> (:error-cb options) (apply [e])))}
                                                {:operation_uid operation-uid
                                                 :filing_type filing-type
                                                 :task_id (:task_id (util/get-location-params))}]))]
                                [:div.dropdown.c-actions {:style {:display :inline} :key :add}
                                 [:div.dropdown-container
                                  [:span
                                   [:button 
                                    {:ref (fn [com] (reset! ref com)) 
                                     :on-click (util/handler 
                                                (fn []
                                                  (cond
                                                    (and (:has-errors options) (not file-with-errors-enabled?)) (set-flash :error "Document has errors. Please correct them before filing the BOIR document.")
                                                    (str/blank? @filing-type-atom) (set-flash :error "Please select filing type first.")
                                                    (and (:has-errors options) file-with-errors-enabled?) (common/show-confirmation-modal
                                                                           {:title   "File BOIR"
                                                                            :text   "Document has errors. Are you sure you want to file BOIR document?"
                                                                            :ok-cb  #(add-fn @filing-type-atom)})
                                                    :else (add-fn @filing-type-atom))))
                                     :disabled (:disabled options)}
                                    "File BOIR Document"]] ]]))})))

(def filing-types {"" "Not selected"
                   "initial_report" "Initial report"
                   "corrects_amends_prior_report" "Correct prior report"
                   "update_prior_report" "Update prior report"})
                  ;;  "reporting_company_became_exempt" "Newly exempt entity"})


(defn filing-type-chooser [options fincen-id value-atom errors-atom]
  [:div
   [:ul [:li "Document filing type"]]
   [:select {:on-change (reset-from-event value-atom)
             :disabled (:disabled options)
             :value @value-atom}
    (map (fn [value]
           [:option {:value value :key value} (filing-types value)])
         (keys (if fincen-id (dissoc filing-types "initial_report") filing-types)))]
   [:span.error (:filing_type @errors-atom "")]])

(defn boir-preview [options collection]
  (let [boir (subscribe :boir-preview)
        errors (atom {})
        ;; show-transmission-details-button (atom false)
        submission (atom nil)
        filing-type (or (:filing-type-atom options) (atom ""))
        fincen-id (get-in collection [:data :fincen_registration_id])
        load-boir #(controller/dispatch :boir-preview :load (merge {:collection-id (:id collection) 
                                                                    :type (:type options)}
                                                                   (when (not-empty @filing-type) {:filing-type @filing-type})))]
    (add-watch filing-type :changed-filing-type (fn [& _] (load-boir)))
    (load-boir)
    (fn []
      [:div
       [:div.filter.user-filter
        [:div.filter-items
         [:div.o-media--1x05.u-shadow--bottom.u-width--full
          [filing-type-chooser {} fincen-id filing-type errors]
          [:div.o-flex-align__element-floating-bottom-right
           [:button.o-flex-align--element-to-right {:on-click (util/handler #(load-boir))} "Refresh"]]]]]
       [:h2.o-media--medium "BOIR document preview"]
       [:div.o-flex-align--center.boir-form-container.u-border-none.u-margin-top--none
        [:p
         [:emph "In light of a recent federal court order, reporting companies are not currently required to file
beneficial ownership information with FinCEN and are not subject to liability if they fail to do so while the
order remains in force. However, reporting companies may continue to voluntarily submit beneficial ownership
information reports."]]
        [:p.u-margin-top
         [:emph "More information is available on FinCEN’s website at " [:a {:href "https://www.fincen.gov/boi"} "https://www.fincen.gov/boi"]]]]

       (util/html-elem :div (:html @boir))
       (when (seq (:uid @boir))
         [:div.u-flex.u-flex--justify-content-center.u-margin-bottom
          (when (= :pdf (:type options))
            [boir-add-document-button nil (:uid @boir) filing-type])
          " "
          (when (and
                  (= :efile (:type options))
                  (not @submission))
            [boir-file-document-button {:success-cb (fn [file-response]
                                                      (reset! submission file-response)
                                                      (util/set-location (str "#/task/details/" (:task_id (util/get-location-params)) "/?fs=1")) )
                                        :has-errors (:has_errors @boir)} (:uid @boir) filing-type])
          " "
          #_(when (and
                  (= :efile (:type options))
                  @submission)
            [:button {:on-click (util/handler
                                  (fn []
                                    (util/set-location (str "#/task/details/" (:task_id (util/get-location-params)) "/"))))} "Go to Task"])])])))

(defn boir-preview-standalone [type collection ancestor-list]
  (let [filing-type (atom "")]
    [:div
     [header
      :supertitle (when (> (count ancestor-list) 1) [breadcrumb ancestor-list false])
      :title (collection-name collection)
      :aside-title (if (= :efile type) "BOIR preview (E-File)" "BOIR preview")
      :subsubtitle [:p.u-font-size--larger (str (get-in collection [:collection_type :asset_type :name]) ": " (get-in collection [:collection_type :name]))]
      :controls [:div
                 [:button {:on-click #(go-to-last-waypoint :collection-details :id (:id collection))} "Back"]]]
     [boir-preview {:hide-refresh-button true :filing-type-atom filing-type :type type} collection]]))

